import { Flex, genesisStyled } from '@leagueplatform/genesis-commons';

export const HealthAssessmentBackground = genesisStyled(Flex)`
  ${({ isMobile }) => (isMobile ? "height: 'auto'" : "height: '100vh'")};
  overflow: 'hidden',
  `;
